import tw, { styled } from 'twin.macro';

export const QuoteWrapper = styled.figure`
  ${tw`m-0`}
  ${tw`flex flex-col-reverse gap-2 md:block`}
  ${tw`p-3 md:py-4 md:px-5`}
  ${tw`rounded-xl`}
  ${tw`bg-ui-colours-ui1`}
  ${tw`font-poppins font-semi-bold`}
  ${tw`text-center md:text-left text-primary-p1`}
`;

export const QuoteText = styled.div`
  ${tw`text-mobile-heading-xs md:text-heading-s`}
  ${tw`mb-3`}
  a {
    ${tw`underline`}
  }
`;

export const QuoteAuthor = styled.figcaption`
  ${tw`mt-0`}
  ${tw`py-0 md:py-2`}
  ${tw`text-mobile-heading-xxs md:text-heading-xxs`}
  ${tw`flex flex-col-reverse gap-2 items-center md:flex-row md:justify-start`}
  & > span {
    ${tw`text-primary-p1`}
  }
`;

export const QuoteLogo = styled.img`
  ${tw`inline-block`}
  ${tw`max-h-3`}
`;
